namespace Matrix.Rebalancer {
    export interface HoldingWhitelistForm {
        AccountCode: FormatServiceLookupEditor;
        SecurityId: FormatServiceLookupEditor;
        CreatedBy: StaticTextBlock;
        CreatedWhen: ReadOnlyDateTime;
        UpdatedBy: StaticTextBlock;
        UpdatedWhen: ReadOnlyDateTime;
        Version: StaticTextBlock;
    }

    export class HoldingWhitelistForm extends Serenity.PrefixedContext {
        static formKey = 'Rebalancer.HoldingWhitelist';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!HoldingWhitelistForm.init)  {
                HoldingWhitelistForm.init = true;

                var s = Serenity;
                var w0 = FormatServiceLookupEditor;
                var w1 = StaticTextBlock;
                var w2 = ReadOnlyDateTime;

                Q.initFormType(HoldingWhitelistForm, [
                    'AccountCode', w0,
                    'SecurityId', w0,
                    'CreatedBy', w1,
                    'CreatedWhen', w2,
                    'UpdatedBy', w1,
                    'UpdatedWhen', w2,
                    'Version', w1
                ]);
            }
        }
    }
}
